import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

export type WhatsAppWhitelist = { phones: string[] };

export function useWhatsAppWhitelist() {
  return useQuery({
    queryKey: ["whatsapp-whitelist"],
    queryFn: () => api.get<WhatsAppWhitelist>("/crm/whatsapp/whitelist"),
  });
}

export function useSaveWhitelist() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (phones: string[]) =>
      api.put<WhatsAppWhitelist>("/crm/whatsapp/whitelist", { phones }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["whatsapp-whitelist"] });
      toast.success("Lista guardada");
    },
  });
}
